var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { GateRecommendationDecisionPicker } from '@app/Components/GateRecommendationDecisionPicker/GateRecommendationDecisionPicker';
import { Api } from '@app/Api';
import { Button } from '@app/Components/Button/Button';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { GateRecommendationDecisionEnum, StatusEnum, GateProcessTypeEnum, SignalREvents } from '@app/AppConstants';
import { signalRService } from '@app/Services/SignalRService';
import { CommentModal } from '@app/Widgets/CommentModal/CommentModal';
export var DecisionTable = /** @class */ (function (_super) {
    __extends(DecisionTable, _super);
    function DecisionTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isDenyCommentModalOpen = false;
        _this._loading = false;
        return _this;
    }
    DecisionTable.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._load()];
                    case 1:
                        _a.sent();
                        signalRService.subscribe(SignalREvents.actionItemsChanged, this._load);
                        return [2 /*return*/];
                }
            });
        });
    };
    DecisionTable.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.actionItemsChanged, this._load);
    };
    DecisionTable.prototype._updateDesision = function (desission) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._recommendation && desission && this._recommendation.decision !== desission)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.updateGateMeetingDecision(this._recommendation.id, {
                                decision: desission
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._load()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DecisionTable.prototype._setToInApprovalStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._recommendation) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.setGateMeetingStatusToInApproval(this._recommendation.id)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._load()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DecisionTable.prototype._approveDecisionStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._recommendation) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.approveGateMeetingDecision(this._recommendation.id)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._load()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DecisionTable.prototype._denyDecisionStatus = function (comment) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._recommendation) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.denyGateMeetingDecision(this._recommendation.id, { comment: comment })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._load()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DecisionTable.prototype._toggleDenyCommentModalOpen = function () {
        this._isDenyCommentModalOpen = !this._isDenyCommentModalOpen;
    };
    DecisionTable.prototype._load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 2, 3]);
                        this._loading = true;
                        _a = this;
                        return [4 /*yield*/, Api.secured.getGateMeeting({ gateId: this.props.gateId })];
                    case 1:
                        _a._recommendation = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DecisionTable.prototype, "hasDenyComment", {
        get: function () {
            return this._recommendation && this._recommendation.denyComment;
        },
        enumerable: false,
        configurable: true
    });
    DecisionTable.prototype.render = function () {
        var _a;
        var _this = this;
        var isMilestoneProject = (_a = this.props, _a.isMilestoneProject), isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { dataSource: [this._recommendation], loading: this._loading },
                React.createElement(Column, { caption: isMilestoneProject ? 'Milestone' : 'Gate', dataField: "gateName", width: 100, allowEditing: false }),
                React.createElement(Column, { caption: "Master Checklist", dataField: "masterCheckListCode", width: 150, allowEditing: false }),
                React.createElement(Column, { caption: "Decision", allowEditing: false, minWidth: 200, cellRender: function (_a) {
                        var _b;
                        var data = _a.data;
                        return (React.createElement(GateRecommendationDecisionPicker, { disabled: ((_b = _this._recommendation) === null || _b === void 0 ? void 0 : _b.status) !== StatusEnum.Draft ||
                                !data.canPrincipalUpdateDecision ||
                                isProjectTerminatedOrCompleted, recommendationId: data.id, gateId: _this.props.gateId, gateProcessType: GateProcessTypeEnum.GateMeeting, defaultValue: data.decision, onChangeHandler: function (d) { return _this._updateDesision(d.value); } }));
                    } }),
                React.createElement(Column, { caption: "Status", dataField: "status", width: 200, allowEditing: false }),
                this.hasDenyComment && React.createElement(Column, { caption: "Comment", dataField: "denyComment", allowEditing: false }),
                React.createElement(Column, { caption: "Actions", width: 200, allowEditing: false, cellRender: function (_a) {
                        var data = _a.data;
                        return data.decision !== GateRecommendationDecisionEnum.NotSpecified &&
                            data.status !== StatusEnum.Approved ? (React.createElement("div", { style: { display: 'flex' } },
                            data.status === StatusEnum.Draft && data.canPrincipalUpdateDecision && (React.createElement(Button, { size: "sm", color: data.canDecisionBeDirectlyApproved ? 'success' : 'primary', onClick: _this._setToInApprovalStatus, disabled: isProjectTerminatedOrCompleted }, data.canDecisionBeDirectlyApproved ? 'Approve' : 'Ready for Approval')),
                            data.status === StatusEnum.InApproval && data.canPrincipalApproveDecision && (React.createElement(React.Fragment, null,
                                React.createElement(Button, { size: "sm", style: { marginRight: 5 }, onClick: _this._toggleDenyCommentModalOpen, disabled: isProjectTerminatedOrCompleted }, "Deny"),
                                React.createElement(Button, { size: "sm", color: "success", onClick: _this._approveDecisionStatus, disabled: isProjectTerminatedOrCompleted }, "Approve"))))) : null;
                    } })),
            React.createElement(CommentModal, { isOpen: this._isDenyCommentModalOpen, onToggle: this._toggleDenyCommentModalOpen, onSave: this._denyDecisionStatus })));
    };
    __decorate([
        observable
    ], DecisionTable.prototype, "_recommendation", void 0);
    __decorate([
        observable
    ], DecisionTable.prototype, "_isDenyCommentModalOpen", void 0);
    __decorate([
        observable
    ], DecisionTable.prototype, "_loading", void 0);
    __decorate([
        action.bound
    ], DecisionTable.prototype, "_setToInApprovalStatus", null);
    __decorate([
        action.bound
    ], DecisionTable.prototype, "_approveDecisionStatus", null);
    __decorate([
        action.bound
    ], DecisionTable.prototype, "_denyDecisionStatus", null);
    __decorate([
        action.bound
    ], DecisionTable.prototype, "_toggleDenyCommentModalOpen", null);
    __decorate([
        action.bound
    ], DecisionTable.prototype, "_load", null);
    __decorate([
        computed
    ], DecisionTable.prototype, "hasDenyComment", null);
    DecisionTable = __decorate([
        observer
    ], DecisionTable);
    return DecisionTable;
}(React.PureComponent));
